import React from 'react'
import { Link } from 'react-router-dom'
import { Segment as UnstyledSegment, Button, Label } from 'semantic-ui-react'
import tw, { styled } from 'twin.macro'

import DeleteConfirmationButton from 'organisms/DeleteConfirmationButton'
import { widgetLabelMap } from 'components/Admin/FeedbackWidgetSettings'
import { AllowPermission } from 'shared/components/AllowPermission'
import constants from 'config/constants'

/**
 * @param {object} props
 * @param {import('pages/Admin/TestimonialsV2').Widget} props.widget
 * @param {() => void} props.onDelete
 * @param {boolean} props.deleteWidgetAPILoading
 * @param {string} props.workspaceToken
 */
export default function IndividualWidgetSegment({
  widget,
  onDelete,
  deleteWidgetAPILoading,
  workspaceToken,
}) {
  return (
    <Segment>
      <WidgetName>
        {widget.name}
        <Label basic className="!ml-4">
          {widgetLabelMap[widget.type]}
        </Label>
      </WidgetName>

      <ButtonGroup>
        <Link to={`/${workspaceToken}/settings/feedback-widgets/${widget.id}/`}>
          <Button basic icon>
            <i className="far fa-edit icon" />
          </Button>
        </Link>
        <AllowPermission permission={constants.permissions.manageFeedbackWidgets}>
          <DeleteConfirmationButton
            actionButtonLabel="Delete widget"
            title="Delete widget"
            description="You’re going to delete this widget. All settings of this widget will be deleted and the widgets you’ve already installed on your website will disappear."
            onDelete={onDelete}
            loading={deleteWidgetAPILoading}
          >
            <Button basic icon>
              <i className="far fa-trash-can icon" />
            </Button>
          </DeleteConfirmationButton>
        </AllowPermission>
      </ButtonGroup>
    </Segment>
  )
}

const Segment = styled(UnstyledSegment)`
  ${tw`border flex justify-between items-center`}
`
const WidgetName = styled.h4`
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const ButtonGroup = styled.div`
  min-width: 90px;
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IndividualWidgetSegment/index.js